<button mat-flat-button color="primary" (click)="createNewReleaseNote()">
  {{ releaseNoteId ? 'EDIT' : 'CREATE RELEASE NOTE' }}
</button>
